import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import { getData } from './utils';
const selectableData = getData().map(i => {
    i.selected = false;
    return i;
});
selectableData[1].selected = true;
let DemoSingleSelect = class DemoSingleSelect extends LitElement {
    constructor() {
        super(...arguments);
        this.data = selectableData;
        this.selectedItem = selectableData[1];
    }
    render() {
        return html `
      <cds-grid>
        <cds-grid-column width="50"></cds-grid-column>
        <cds-grid-column>Stock</cds-grid-column>
        <cds-grid-column>Average</cds-grid-column>
        <cds-grid-column>Current</cds-grid-column>
        <cds-grid-column>About</cds-grid-column>
        ${this.data.map(entry => html `
          <cds-grid-row .select=${entry.selected}>
            <cds-grid-cell>
              <cds-radio>
                <label><span style="display: none">select ${entry.id}</span></label>
                <input type="radio" name="grid-rows" .checked=${entry.selected} value=${entry.id} aria-label="" @click=${(e) => this.select(entry, e.target.checked)} />
              </cds-radio>
            </cds-grid-cell>
            <cds-grid-cell>
              ${entry.id}
            </cds-grid-cell>
            <cds-grid-cell>$${entry.average}</cds-grid-cell>
            <cds-grid-cell>$${entry.value}</cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer>
          Selected: ${this.selectedItem.id}
        </cds-grid-footer>
      </cds-grid>
    `;
    }
    select(entry, checked) {
        this.data.forEach(i => i.selected = false);
        this.selectedItem = this.data.find(i => i.id === entry.id);
        this.selectedItem.selected = checked;
        this.data = [...this.data];
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoSingleSelect.prototype, "data", void 0);
__decorate([
    internalProperty()
], DemoSingleSelect.prototype, "selectedItem", void 0);
DemoSingleSelect = __decorate([
    customElement('demo-single-select')
], DemoSingleSelect);
export { DemoSingleSelect };
//# sourceMappingURL=demo.row-single-select.js.map